import {OptionRecherche} from "./OptionRecherche.js";
import {CritèreRecherche} from "./CritèreRecherche.js";

export class Recherche {

    critères = new Map();
    options = new Map();
    nom = "";
    description = "";
    hash;

    constructor(critères, options, nom) {
        this.nom = nom || "";
        this.critères = this.getCritèresRechercheMap(critères);
        this.options = this.getOptionsRechercheMap(options);
        this.hash = Recherche.getHash(this);
    }

    hasCible(cible) {
        if (!this.critères || this.critères.size === 0) {
            return false;
        }
        return [...this.critères.entries()].some((critère) => {
            return critère.some((c) => {
                return c.cible === cible.code
            });
        });
    }

    matchCodeCible(codeCibleRegex) {
        if (!this.critères || this.critères.size === 0) {
            return false;
        }
        return [...this.critères.entries()].some((critère) => {
            return critère.some((c) => {
                return codeCibleRegex.test(c.cible);
            });
        });
    }

    getCritèresRechercheMap(critères) {
        {
            if (!critères) return new Map();

            if (!(critères instanceof Map || critères instanceof Array)) {
                console.error("critères n'est ni une Map ni un Array", critères.constructor.name, critères);
                return new Map();
            }

            if (critères instanceof Map) {
                if (critères.entries().next().value instanceof CritèreRecherche) {
                    return critères;
                }
                // critères n'est pas une Map de CritèreRecherche
                const critèresRechercheMap = new Map();
                critères.forEach((critère, clé) => {
                    critèresRechercheMap.set(clé, new CritèreRecherche(critère.cible, critère.comparateur, critère.valeurs));
                })
                return critèresRechercheMap;
            }

            return critères;

        }
    }

    getOptionsRechercheMap(options) {
        {
            if (!options) return new Map()
                .set(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code, new OptionRecherche(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code, "oui"))
                .set(OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code, new OptionRecherche(OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code, "oui"));


            if (!(options instanceof Map || options instanceof Array)) {
                console.error("options n'est ni une Map ni un Array", options.constructor.name, options);
                return new Map();
            }
            if (options instanceof Map) {
                if (options.entries().next().value instanceof OptionRecherche) {
                    return options;
                }
                // options n'est pas une Map d'OptionsRecherche
                const optionsRechercheMap = new Map();
                options.forEach((option, clé) => {
                    optionsRechercheMap.set(clé, new OptionRecherche(option.code, option.valeur));
                })
                return optionsRechercheMap;
            }

            return options;

        }
    }

    clone() {
        const recherche = new Recherche(new Map(this.critères), new Map(this.options));
        recherche.nom = this.nom;
        return recherche;
    }

    static prépareSérialisation(recherche) {
        return {
            nom: recherche.nom,
            critères: [...recherche.critères.values()],
            options: [...recherche.options.values()]
        };
    }

    static sérialise(recherche) {
        return JSON.stringify(Recherche.prépareSérialisation(recherche));
    }

    //https://stackoverflow.com/a/52171480/3892033
    static cyrb53(str, seed = 0) {
        let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
        for (let i = 0, ch; i < str.length; i++) {
            ch = str.charCodeAt(i);
            h1 = Math.imul(h1 ^ ch, 2654435761);
            h2 = Math.imul(h2 ^ ch, 1597334677);
        }
        h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
        h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
        h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
        h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

        return 4294967296 * (2097151 & h2) + (h1 >>> 0);
    }

    static getHash(recherche) {
        let str = Recherche.sérialise(recherche);
        return Recherche.cyrb53(str);
    }

    static désérialise(rechercheSérialisée, cr) {
        let rechercheBrute;

        try {
            rechercheBrute = JSON.parse(rechercheSérialisée);
        } catch (erreur) {
            console.error("N'est pas une recherche valide : ", rechercheSérialisée);
            return {};
        }

        if (rechercheBrute && Object.keys(rechercheBrute).length > 0) {
            return Recherche.ofRechercheBrute(rechercheBrute, cr);
        } else return {};
    }


    static ofRechercheBrute(rechercheBrute, cr) {
        let critères = new Map(rechercheBrute.critères.map(c =>
            [cr.getClé(c), new CritèreRecherche(c.cible, c.comparateur, c.valeurs)])
        );
        let options = new Map(rechercheBrute.options.map(o => [o.code, o]));

        return new Recherche(critères, options, rechercheBrute.nom);
    }

    /**
     * Deux recherches sont identiques si elles ont le même nombre de critères et d'option
     * et que chaque critère et options sont identiques.
     * @param recherche
     */
    égale(recherche) {

        if (!recherche
            || recherche.critères.size !== this.critères.size
            || recherche.options.length !== this.options.length
        ) {
            return false;
        }

        // TODO comparer valeurs des critères (via méthode CritèreRecherche.égale()) et options

        return true;
    }


}
